import { colors } from '../tokens';

/** MUI Switch override — checked state uses secondary (green) color. */
const MuiSwitch = {
  styleOverrides: {
    root: {
      padding: 8,
    },
    switchBase: {
      '&.Mui-checked': {
        color: colors.secondary.main,
        '& + .MuiSwitch-track': {
          backgroundColor: colors.secondary.main,
          opacity: 1,
          border: 0,
        },
        '&.Mui-disabled + .MuiSwitch-track': {
          opacity: 0.5,
        },
      },
    },
    track: {
      borderRadius: 26 / 2,
      backgroundColor: colors.text.disabled,
      opacity: 1,
    },
    thumb: {
      boxSizing: 'border-box',
      width: 22,
      height: 22,
    },
  },
};

export default MuiSwitch;
